export function isValidIsraeliId(id: string | number): boolean {
  if (!id) return false
  let israeliId = String(id).trim()
  if (israeliId.length > 9 || israeliId.length < 5 || isNaN(Number(israeliId))) return false
  israeliId = israeliId.length < 9 ? ('00000000' + israeliId).slice(-9) : israeliId
  return (
    Array.from(israeliId, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1)
      return counter + (step > 9 ? step - 9 : step)
    }) %
      10 ===
    0
  )
}
